import React from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { HealthServiceDataViewStatus } from "./HealthStatusService";

const HealthStatusServiceJunoAggregatorConsumer = ({ data }) => {

    const tab1_col = [
        {
            field: "account_id",
            headerName: "Account ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            cellStyle: function (params) {
                if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.value === 'DISABLED') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
    ]

    const tab2_col = [
        {
            field: "market",
            headerName: "Market",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "status",
            headerName: "Status",
            cellStyle: function (params) {
                if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.value === 'DISABLED') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            },
            minWidth: 200,
        },
    ]

    let tab1_data = []
    if (data.accounts) {

        tab1_data = Object.keys(data.accounts).sort((a, b) => (data.accounts[a].status === 'up') ? 1 : -1).reduce(
            (rowData, rowId) => {

                const row = data.accounts[rowId]

                rowData.push({
                    'uniqueId': row.id,
                    'account_id': row.id,
                    'status': row.status
                })

                return rowData

            }, [])

    }

    let tab2_data = []
    if (data.market_status) {

        tab2_data = Object.keys(data.market_status).sort((a, b) => (data.market_status[a].status === 'up') ? 1 : -1).reduce(
            (rowData, rowId) => {

                const row = data.market_status[rowId]

                rowData.push({
                    'uniqueId': row.attr,
                    'market': row.attr.split("TT_MARKET_ID_")[1],
                    'status': row.status
                })

                return rowData

            }, [])

    }

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Accounts</Text>
                <HealthServiceDataViewStatus tab_data={tab1_data.map(function (item) {
                    return item["status"]
                })} />
            </Box>
            <>
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Accounts</Text>

                <AgDataTable
                    tab_col={tab1_col}
                    tab_data={tab1_data}
                    tableName="HealthStatusServiceJunoAggregatorConsumerAccounts"
                    defaultSubTab="Account"
                    countTitle="Accounts"
                    tableHeight={700}
                />

                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Markets</Text>

                <AgDataTable
                    tab_col={tab2_col}
                    tab_data={tab2_data}
                    tableName="HealthStatusServiceJunoAggregatorConsumerMarkets"
                    defaultSubTab="Market"
                    countTitle="Markets"
                    tableHeight={700}
                />
            </>
        </Box>
    )

}

export default HealthStatusServiceJunoAggregatorConsumer